module.exports = __webpack_public_path__ + "img/renwu.131a4a15.png";